
const About = () => {
  const stats = [
    { number: '2,500+', label: 'Successful Relocations' },
    { number: '98%', label: 'Client Satisfaction Rate' },
    { number: '50+', label: 'Corporate Partners' },
    { number: '24/7', label: 'Dedicated Support' }
  ];

  return (
    <section id="about" className="py-24 px-8 md:px-16 lg:px-24 bg-amber-50">
      <div className="max-w-7xl mx-auto">
        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl font-bold text-orange-600 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                {stat.number}
              </div>
              <div className="text-gray-600 text-sm font-medium uppercase tracking-wide whitespace-nowrap">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
